import { TurretActor } from "./TurretActor";
import { GameVars } from "../../../GameVars";

export class ConstructionBar extends Phaser.GameObjects.Container {

    private bar: Phaser.GameObjects.Image;
    private turretActor: TurretActor;

    constructor(scene: Phaser.Scene, turretActor: TurretActor) {

        super(scene);

        this.y = 38;
        this.turretActor = turretActor;

        this.bar = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "progress_bar_01");
        this.add(this.bar);
    }

    public update(): void {

        let percentage: number;
        
        if (this.turretActor.anutoTurret.constructionTicks) {
            percentage = this.turretActor.anutoTurret.t2 / this.turretActor.anutoTurret.constructionTicks;
        } else {
            percentage = this.turretActor.anutoTurret.t2 / this.turretActor.anutoTurret.upgradeTicks;
        }

        percentage = Math.round(percentage * 40);

        if (percentage > 0) {

            let percentageStr: string;

            if (percentage < 10) {
                percentageStr = "0" + percentage;
            } else {
                percentageStr = percentage.toString();
            }
    
            this.bar.setFrame("progress_bar_" + percentageStr);
        }
    }
}
